import { useAtParentIndex, useParent } from '../utils/components';
import { STEPS_BIND_STEP_KEY, STEPS_COUNT_STEP_KEY } from '../steps/provide';
export function useSteps() {
  var {
    parentProvider,
    bindParent
  } = useParent(STEPS_BIND_STEP_KEY);
  var {
    index
  } = useAtParentIndex(STEPS_COUNT_STEP_KEY);

  if (!parentProvider || !bindParent || !index) {
    throw Error('[Varlet] Steps: <step/> must in <steps>');
  }

  return {
    index,
    steps: parentProvider,
    bindSteps: bindParent
  };
}